export default __webpack_public_path__ + "static/media/IMG_8556.c1369097.JPG";